export default {
  getProject(state) {
    return state.project;
  },
  getProjects(state) {
    return state.projects;
  },
  getProjectsMap(state) {
    return state.projects?.reduce((prev, next) => {
      const { id } = next;
      prev[id] = next;
      return prev;
    }, {});
  },
};
